import { NavigationLayout } from "components/Navigation/NavigationLayout";
import { SvgCgu, SvgSatification, SvgTutorialsVideo, SvgVersions, SvgChat, SvgArrow } from "components/svg";
import { APP_URL } from "utils/defines";

import { CGUPage } from "./CGUPage";
import { FAQPage } from "./FAQPage";
import { ChangeLogPage } from "./ChangeLog";
import { SatisfactionPage } from "./Satisfaction";
import { VideoPage } from "./VideoPage";
import useTranslation from "utils/hooks/useTranslation";

export const HelpPage: React.FC = () => {
  const { t } = useTranslation();
  const navigationItems = [
    { key: 'home', url: APP_URL.Help, icon: <SvgTutorialsVideo />, title: "Tutoriels vidéo", component: <VideoPage />, showTitle: true, showTitleMobile: false },
    { key: 'faq', url: APP_URL.FAQ, icon: <SvgChat />, title: t("FAQ"), component: <FAQPage />, showTitle: true, showTitleMobile: false },
    { key: 'changelog', url: APP_URL.Changelog, icon: <SvgVersions />, title: t("IMPROVEMENT"), component: <ChangeLogPage />, showTitle: true, showTitleMobile: false },
    { key: 'cgu', url: APP_URL.CGU, icon: <SvgCgu />, title: t("CGU"), component: <CGUPage />, showTitle: false, showTitleMobile: false },
    { key: 'satisfaction', url: APP_URL.Satisfaction, icon: <SvgSatification />, secondIcon: <SvgArrow />, title: "Questionnaire de satifaction", component: <SatisfactionPage />, showTitle: true, showTitleMobile: false },
  ];

  const isHelpItemSelected = (item: any, currentPage: string) => {
    return item.key === currentPage;
  };

  return (
    <NavigationLayout
      defaultPage="home"
      items={navigationItems}
      isSelected={isHelpItemSelected}
    />
  );
};




// import { Page } from "components/Page";
// import Ripple from "components/Ripple";
// import { useLocation, useNavigate, useParams } from "react-router";
// import { useEffect, useState } from "react";
// //import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
// //import useTranslation from "utils/hooks/useTranslation";
// import { APP_URL, getAppUrl } from "../../utils/defines";
// import { CGUPage } from "./CGUPage";
// import { FAQPage } from "./FAQPage";
// import { ChangeLogPage } from "./ChangeLog";
// import { SatisfactionPage } from "./Satisfaction";
// import { VideoPage } from "./VideoPage";
// import { SvgCgu, SvgSatification, SvgTutorialsVideo, SvgVersions } from "components/svg";
// import { SvgChat } from "components/svg";
// import NewProjectWidget from "components/NewProjectWidget";

// export const HelpPage: React.FC = () => {
//   const { section } = useParams();
//   const location = useLocation();
//   //const { language } = useTranslation();
//   //const { network } = useSalesNetwork();
//   const navigate = useNavigate();
//   const [currentPage, setCurrentPage] = useState('home');

//   const navigationItems = [
//     { key: 'home', url: APP_URL.Help, icon: <SvgTutorialsVideo />, title: "Tutoriels vidéo", selected: currentPage === 'home', component: <VideoPage />, showTitle: true },
//     { key: 'faq', url: APP_URL.FAQ, icon: <SvgChat />, title: "FAQ", selected: currentPage === 'faq', component: <FAQPage />, showTitle: true },
//     { key: 'changelog', url: APP_URL.Changelog, icon: <SvgVersions />, title: "Améliorations", selected: currentPage === 'changelog', component: <ChangeLogPage />, showTitle: true },
//     { key: 'cgu', url: APP_URL.CGU, icon: <SvgCgu />, title: "CGU", selected: currentPage === 'cgu', component: <CGUPage />, showTitle: false },
//     { key: 'satisfaction', url: APP_URL.Satisfaction, icon: <SvgSatification />, title: "Questionnaire de satifaction", selected: currentPage === 'satisfaction', component: <SatisfactionPage />, showTitle: true },
//   ]

//   useEffect(() => {
//     if (location.pathname.endsWith("/satisfaction")) {
//       setCurrentPage('satisfaction');
//     } else {
//       setCurrentPage(section ?? 'home');
//     }
//   }, [section])

//   const currentItem = navigationItems.filter((i) => i.key === currentPage)[0];

//   //console.log(currentItem)

//   return (
//     <group data-direction="column" data-align="center" data-height="autofit">
//       <group data-wrap="no" data-height="fit" data-max-length="1440">
//         <group
//           data-space-vertical="20" 
//           data-gap="20" data-direction="column" data-fit="1" data-max-length="300">
//           <group data-wrap="no"
//             data-space-vertical="20"
//             data-gap="10" data-direction="column" data-background="white" data-elevation="6" data-radius="15" className="group-fixed-top">
//             {
//               navigationItems.map((item: any) => {
//                 return (
//                   <group
//                     key={item?.key}
//                     data-contain=""
//                     data-shrink="no"
//                     data-name="autoseparation"
//                     data-wrap="no"
//                     data-align="center"
//                     data-width="autofit"
//                     data-gap="10"
//                     {...(item.selected ? { "data-state": "selected" } : {})}
//                     >

//                     <group data-name="autoseparation_separator" data-height="fit" data-length="5"></group>

//                       <group
//                         //data-height="fit"
//                         data-length="autofit"                        
//                         data-cursor="pointer"
//                         data-align="center"
//                         data-height="40"
//                         data-space="10"
//                         data-gap="5"
//                         data-wrap="no"
//                         data-radius="5"
//                         data-contain=""
//                         onClick={() => {
//                           setCurrentPage(item?.key)
//                           navigate(getAppUrl(item.url));
//                         }}                        
//                       >
//                         <icon data-svg-size="16" data-svg-color="main">{item?.icon}</icon>
//                         <text data-wrap="wrap">{item?.title}</text>
//                       </group>

//                   </group>
//                 )
//               })
//             }

//           </group>

//           <NewProjectWidget />
//         </group>
//         <group
//           data-space="20" data-gap="20" data-fit="2" data-direction="column" data-wrap="no"
//         //style={{ backgroundColor: "yellow" }}
//         >
//           {currentItem?.showTitle && <group data-wrap="no" data-space-top="20" data-gap="20" data-max-length="1440">
//             <group data-height="fit" data-length="5" data-background="main"></group>
//             <group data-length="autofit">
//               <text data-color="main" data-text-size="40">{currentItem?.title}</text>
//             </group>
//           </group>}
//           <group >
//             {
//               currentItem?.component
//             }
//           </group>
//         </group>
//       </group>
//     </group>
//   );
// };
